import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { CheckmarkIcon } from '@honestica/curecall-ui'
import { twMerge } from 'src/utils/tw-merge.util'

export type TStep = 1 | 2 | 3 | 4

type TStepConfig = {
  step: TStep
  labelKey: string
}

const STEPS: TStepConfig[] = [
  { step: 1, labelKey: 'pages.hr.campaigns.new.steps.type-selection' },
  { step: 2, labelKey: 'pages.hr.campaigns.new.steps.contacts' },
  { step: 3, labelKey: 'pages.hr.campaigns.new.steps.message' },
  { step: 4, labelKey: 'pages.hr.campaigns.new.steps.confirmation' },
]

export const CampaignCreationStepper = ({ currentStep }: Readonly<{ currentStep: TStep }>) => {
  const { t } = useTranslation()

  return (
    <div className="c-flex c-items-start c-w-full c-px-4">
      {STEPS.map(({ step, labelKey }, index) => {
        const isCompleted = step < currentStep
        const isCurrent = step === currentStep

        return (
          <Fragment key={step}>
            {index > 0 && (
              <div
                className={twMerge(
                  'c-flex-1 c-h-0.5 c-mt-4 c-shrink',
                  isCompleted || isCurrent ? 'c-bg-primary' : 'c-bg-grey-200',
                )}
              />
            )}

            <div className="c-flex c-flex-col c-items-center">
              <div
                className={twMerge(
                  'c-w-8 c-h-8 c-rounded-full c-flex c-items-center c-justify-center c-text-sm c-font-semibold c-shrink-0',
                  isCompleted || isCurrent ? 'c-bg-primary c-text-white' : 'c-bg-grey-100 c-text-grey-400',
                )}
              >
                {isCompleted ? <CheckmarkIcon className="c-w-4 c-h-4" /> : step}
              </div>
              <span
                className={twMerge(
                  'c-text-xs c-mt-1 c-text-center c-whitespace-nowrap',
                  isCurrent
                    ? 'c-text-primary c-font-semibold'
                    : isCompleted
                      ? 'c-text-grey-600'
                      : 'c-text-grey-400',
                )}
              >
                {t(labelKey)}
              </span>
            </div>
          </Fragment>
        )
      })}
    </div>
  )
}
